import { z } from 'zod';
import { auctionsOfAuctionTileSortByValues } from 'src/apis/transport-auction/mappings';
import {
  ascSortDirectionSchema,
  getPaginationSchema,
} from 'src/components/form/zod-schemas';

export const auctionsParamsSchema = z
  .object({
    sortBy: z
      .enum(auctionsOfAuctionTileSortByValues)
      .default('NETWORK_POINT_OR_BUNDLE_NAME'),
    sortDirection: ascSortDirectionSchema,
  })
  .merge(getPaginationSchema());
